module.exports = __webpack_public_path__ + "img/pioneer-mockup-bnw.a3113de3.jpg";